import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import { connectRouter } from 'connected-react-router'
import persistState from 'redux-localstorage'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { camelCase, isEmpty } from 'lodash'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import reduxReset from 'redux-reset'
import API from './api'

import { authenticationReducerDefaultState } from 'reducers/authentication'

// REDUCERS
let reducers = {}
let defaults = {}
const reducersReq = require.context('../reducers', true, /^(.*\.(js$))[^.]*$/im)
reducersReq.keys().forEach(key => {
  const reducerName = camelCase(key.match(/.\/([\w-]+).js/)[1])
  reducers[reducerName] = reducersReq(key).default
  defaults[reducerName] = reducersReq(key)[`${reducerName}ReducerDefaultState`]
})

export const history = createBrowserHistory()

const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history)]

enhancers.push(
  persistState(null, {
    key: 'EVENT-GIVES-LIVE',
    slicer: paths => {
      return state => {
        return {
          authentication: {
            ...authenticationReducerDefaultState,
            authenticatedUser: state.authentication.authenticatedUser,
            token: state.authentication.token
          }
        }
      }
    },
    merge: (initialState, persistedState) => {
      var token
      var localStorageValue =
        localStorage.getItem('ember_simple_auth:session') ||
        localStorage.getItem('bidr-mobile-staging.user') ||
        localStorage.getItem('bidr-mobile.user')
      if (localStorageValue) {
        // app token
        const json = JSON.parse(localStorageValue)
        if (!isEmpty(json.authenticated)) {
          token = 'Bearer ' + json.authenticated.token
        }
      } else if (persistedState.authentication.token) {
        token = persistedState.authentication.token
      }
      if (token) {
        // decode the token
        const decodedToken = jwtDecode(token)
        // get the expiration as a moment
        const expDate = moment.unix(decodedToken.exp)
        // get today as a moment
        const nowDate = moment()
        // get the difference in hours
        const differenceInHours = nowDate.diff(expDate, 'hours', true)
        // if the difference is greater than an hour throw our the loaded state to force a login
        if (differenceInHours > 1) {
          persistedState = {}
          localStorage.removeItem('ember_simple_auth:session')
          localStorage.removeItem('bidr-mobile-staging.user')
          localStorage.removeItem('bidr-mobile.user')
        } else {
          persistedState.authentication.token = token
          if (isEmpty(persistedState.authentication.authenticatedUser)) {
            persistedState.authentication.authenticatedUser.user_id =
              decodedToken.user_id
          }
          // otherwise allow the loaded state to be hydrated
          API.set('Authorization', token)
        }
      } else {
        persistedState = {}
        localStorage.removeItem('ember_simple_auth:session')
        localStorage.removeItem('bidr-mobile-staging.user')
        localStorage.removeItem('bidr-mobile.user')
      }
      return persistedState
        ? { ...initialState, ...persistedState }
        : initialState
    }
  })
)

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  reduxReset('RESET_STORE'),
  ...enhancers
)

const store = createStore(
  combineReducers({
    router: connectRouter(history),
    ...reducers
  }),
  initialState,
  composedEnhancers
)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js